import { dataSearchDesktop } from 'dls-icons-data'
import { createIcon } from '../common'

const IconSearchDesktop = /*#__PURE__*/createIcon(dataSearchDesktop)
export default IconSearchDesktop
